module.exports = __webpack_public_path__ + "static/img-06.9ef210ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/whipwhip/img-06.png
// module id = 97
// module chunks = 6869407129569 88197199937824 213720915766396